import { segment, type Segment } from '../geom';
import type { LineNode } from '../model';
import { evaluatePoint, pointFields, pointValues } from './parts';
import type { EntityDefinition } from './types';

export const LINE: EntityDefinition<LineNode, Segment> = {
  type: 'line',
  label: 'Line',
  fields: [...pointFields('a', 'Start'), ...pointFields('b', 'End')],
  resolve: (node, evaluate) =>
    segment(evaluatePoint(node.a, evaluate), evaluatePoint(node.b, evaluate)),
  fromShape: (s) => ({ ...pointValues('a', s.a), ...pointValues('b', s.b) }),
};
